export default __webpack_public_path__ + "static/media/bg.1d36091b.jpg";